
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengajuan-hapus-akun",
      function () {
        return require("private-next-pages/pengajuan-hapus-akun/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengajuan-hapus-akun"])
      });
    }
  